module.exports = __webpack_public_path__ + "static/media/cat.73d9c67f.svg";